import { SessionData } from '@/types/analytics';
import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';

type BlockDetailsProps = {
  selectedRow: number;
  sessionData?: SessionData;
};

const BlockDetails: FC<BlockDetailsProps> = ({ selectedRow, sessionData }) => {
  const line = sessionData?.lines.find((line) => line.row === selectedRow);
  const row = 'E' + selectedRow;

  return (
    <Stack p={1} height={'90vh'} width={'100%'} overflow='auto' borderLeft={'1px solid gray'}>
      {selectedRow > 0 && (
        <Stack>
          {line && (
            <Box mb={2}>
              <Typography>Block:</Typography>
              <Typography>
                {`${line.timestamp}: ${line.task} ${line.step}(${line.row}) - ${line.block_id} ${line.block_type} (${line.duration} ms) ${line.sub_name}`}
              </Typography>
            </Box>
          )}
          <Box mb={2}>
            <Typography>Parameters:</Typography>
            {sessionData?.params[row]?.map((param, index) => (
              <Typography key={'param-' + index}>
                {`'${param.label}' (${param.name}) = ${param.value} [${param.parsertype}]`}
              </Typography>
            ))}
          </Box>
          <Box mb={2}>
            <Typography>Result:</Typography>
            {sessionData?.results[row]?.map((result, index) => (
              <Typography
                key={'result-' + index}
              >{`${result.variable} = ${result.value} (${result.valuetype})`}</Typography>
            ))}
          </Box>
          <Box>
            <Typography>Actions:</Typography>
            {sessionData?.actions[row]?.map((action, index) => {
              const label = action.label || `<${action.action}>`;
              const nextBlock = action.nextblock || `- unconnected`;

              return <Typography key={'action-' + index}>{`${label} (${action.action}) => ${nextBlock}`}</Typography>;
            })}
          </Box>
        </Stack>
      )}
    </Stack>
  );
};

export default BlockDetails;
